$( document ).on('turbolinks:load', function() {
	setTimeout(function(){$('.phano_photo').scrollLeft(620);}, 500)
});
